import { writable, get } from 'svelte/store';
import { vendey } from './api.js';
import { COMPANY } from './config.js';
import { readJson } from './storage.js';
const fields = { activarStockObligatorio: ['validarStock', 'true', 'false', true], activarCodigoBarra: ['activadocodbarras', '1', '0', false], mostrarNotificaciones: ['vendeyNotificacionesPushActivas', 'true', 'false', true] };
export const preferences = writable({ rules: {}, status: 'Sin consultar', loading: false });
export function isActive(name) {
  const rule = get(preferences).rules[name];
  if (rule === 'si' || rule === 'no') return rule === 'si';
  const saved = readJson('vendeySvelteOptions:' + COMPANY, {});
  if (rule && saved[name]?.rule === rule) return saved[name].active;
  if (rule) return rule === 'opcionalsi';
  const [key, yes, , defaultValue] = fields[name];
  const value = localStorage.getItem(key);
  return value === null ? defaultValue : value === yes;
}
export function editable(name) { return !get(preferences).loading && !['si', 'no'].includes(get(preferences).rules[name]); }
function apply() { Object.entries(fields).forEach(([name, [key, yes, no]]) => localStorage.setItem(key, isActive(name) ? yes : no)); }
export function changePreference(name, active) {
  if (!editable(name)) return;
  const saved = readJson('vendeySvelteOptions:' + COMPANY, {}); saved[name] = { rule: get(preferences).rules[name], active };
  localStorage.setItem('vendeySvelteOptions:' + COMPANY, JSON.stringify(saved));
  const [key, yes, no] = fields[name]; localStorage.setItem(key, active ? yes : no);
  preferences.update(value => ({ ...value }));
}
export async function loadPreferences() {
  preferences.update(value => ({ ...value, loading: true }));
  try {
    let result = await vendey('spSystemConfigvweb', '1|1|');
    if (result?.CSV) result = JSON.parse(result.CSV);
    if (Array.isArray(result) && result.length === 1) result = result[0];
    const rules = {};
    for (const name of Object.keys(fields)) {
      const entry = Object.entries(result || {}).find(([key]) => key.toLowerCase() === name.toLowerCase());
      const rule = String(entry?.[1] || '').normalize('NFD').replace(/[\u0300-\u036f\s]/g, '').toLowerCase();
      if (['si', 'no', 'opcionalsi', 'opcionalno'].includes(rule)) rules[name] = rule;
    }
    if (!Object.keys(rules).length) throw new Error('No se recibieron reglas reconocidas.');
    preferences.set({ rules, loading: false, status: 'Configuración de empresa aplicada.' }); apply();
  } catch (reason) { preferences.set({ rules: {}, loading: false, status: 'Se mantienen las preferencias locales. ' + reason.message }); }
}
